import '../assets/NcAppNavigation-BjnW8PQn.css';
import { useIsMobile } from "../Composables/useIsMobile.mjs";
import { g as getTrapStack } from "./focusTrap-Cecv_gjR.mjs";
import { subscribe, emit, unsubscribe } from "@nextcloud/event-bus";
import { createFocusTrap } from "focus-trap";
import { N as NcAppNavigationToggle } from "./NcAppNavigationToggle-DfX9dazn.mjs";
import { N as NcAppNavigationList } from "./NcAppNavigationList-DCmrqe9N.mjs";
import { warn, resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, withKeys, renderSlot, createBlock, withCtx, createCommentVNode, createVNode } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _sfc_main = {
  name: "NcAppNavigation",
  components: {
    NcAppNavigationList,
    NcAppNavigationToggle
  },
  // Injected from NcContent
  inject: {
    setHasAppNavigation: {
      default: () => () => warn("NcAppNavigation is not mounted inside NcContent, this is probably an error."),
      from: "NcContent:setHasAppNavigation"
    }
  },
  props: {
    /**
     * The aria label to describe the navigation
     */
    ariaLabel: {
      type: String,
      default: ""
    },
    /**
     * aria-labelledby attribute to describe the navigation
     */
    ariaLabelledby: {
      type: String,
      default: ""
    }
  },
  setup() {
    return {
      isMobile: useIsMobile()
    };
  },
  data() {
    return {
      open: !this.isMobile,
      focusTrap: null
    };
  },
  watch: {
    isMobile() {
      this.open = !this.isMobile;
      this.toggleFocusTrap();
    },
    open() {
      this.toggleFocusTrap();
    }
  },
  mounted() {
    this.setHasAppNavigation(true);
    subscribe("toggle-navigation", this.toggleNavigationByEventBus);
    emit("navigation-toggled", {
      open: this.open
    });
    this.focusTrap = createFocusTrap(this.$refs.appNavigationContainer, {
      allowOutsideClick: true,
      fallbackFocus: this.$refs.appNavigationContainer,
      trapStack: getTrapStack(),
      escapeDeactivates: false
    });
    this.toggleFocusTrap();
  },
  unmounted() {
    this.setHasAppNavigation(false);
    unsubscribe("toggle-navigation", this.toggleNavigationByEventBus);
    this.focusTrap.deactivate();
  },
  methods: {
    /**
     * Toggle the navigation
     *
     * @param {boolean} [state] set the state instead of inverting the current one
     */
    toggleNavigation(state) {
      if (this.open === state) {
        emit("navigation-toggled", {
          open: this.open
        });
        return;
      }
      this.open = typeof state === "undefined" ? !this.open : state;
      const bodyStyles = getComputedStyle(document.body);
      const animationLength = parseInt(bodyStyles.getPropertyValue("--animation-quick")) || 100;
      setTimeout(() => {
        emit("navigation-toggled", {
          open: this.open
        });
      }, 1.5 * animationLength);
    },
    toggleNavigationByEventBus({ open }) {
      this.toggleNavigation(open);
    },
    /**
     * Activate focus trap if it is currently needed, otherwise deactivate
     */
    toggleFocusTrap() {
      if (this.isMobile && this.open) {
        this.focusTrap.activate();
      } else {
        this.focusTrap.deactivate();
      }
    },
    handleEsc() {
      if (this.isMobile) {
        this.toggleNavigation(false);
      }
    }
  }
};
const _hoisted_1 = ["aria-hidden", "aria-label", "aria-labelledby", "inert"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcAppNavigationList = resolveComponent("NcAppNavigationList");
  const _component_NcAppNavigationToggle = resolveComponent("NcAppNavigationToggle");
  return openBlock(), createElementBlock("div", {
    ref: "appNavigationContainer",
    class: normalizeClass(["app-navigation", { "app-navigation--close": !$data.open }])
  }, [
    createElementVNode("nav", {
      id: "app-navigation-vue",
      "aria-hidden": $data.open ? "false" : "true",
      "aria-label": $props.ariaLabel || void 0,
      "aria-labelledby": $props.ariaLabelledby || void 0,
      class: "app-navigation__content",
      inert: !$data.open || void 0,
      onKeydown: _cache[0] || (_cache[0] = withKeys((...args) => $options.handleEsc && $options.handleEsc(...args), ["esc"]))
    }, [
      createElementVNode("div", {
        class: normalizeClass(["app-navigation__body", { "app-navigation__body--no-list": !_ctx.$slots.list }])
      }, [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ], 2),
      _ctx.$slots.list ? (openBlock(), createBlock(_component_NcAppNavigationList, {
        key: 0,
        class: "app-navigation__list"
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "list", {}, void 0, true)
        ]),
        _: 3
      })) : createCommentVNode("", true),
      renderSlot(_ctx.$slots, "footer", {}, void 0, true)
    ], 40, _hoisted_1),
    createVNode(_component_NcAppNavigationToggle, {
      open: $data.open,
      "onUpdate:open": $options.toggleNavigation
    }, null, 8, ["open", "onUpdate:open"])
  ], 2);
}
const NcAppNavigation = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-7aa67221"]]);
export {
  NcAppNavigation as N
};
